import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  template: `
    <div class="cookie-banner" *ngIf="showConsent">
      <p>
        We use cookies to improve your experience and analyze site usage.
        By continuing, you agree to our
        <a href="https://chareety.com/privacy" target="_blank" rel="noopener">Privacy Policy</a>.
      </p>
      <div class="cookie-actions">
        <button mat-stroked-button class="decline-btn" (click)="decline()">Decline</button>
        <button mat-flat-button color="primary" (click)="accept()">Accept</button>
      </div>
    </div>
  `,
  styles: [`
    .cookie-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #1e1e2f;
      color: #e0e0e0;
      padding: 16px 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 24px;
      z-index: 10000;
      box-shadow: 0 -2px 12px rgba(0,0,0,.25);
      font-size: 14px;
    }

    .cookie-banner p {
      margin: 0;
      line-height: 1.5;
      max-width: 640px;
    }

    .cookie-banner a {
      color: var(--chareety-accent, #F07A3D);
      text-decoration: underline;
      font-weight: 500;
    }

    .cookie-banner a:hover {
      color: #fff;
    }

    .cookie-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }

    .decline-btn {
      color: #ccc !important;
      border-color: #555 !important;
    }

    @media (max-width: 600px) {
      .cookie-banner {
        flex-direction: column;
        gap: 12px;
        text-align: center;
        padding: 16px;
      }
    }
  `]
})
export class CookieConsentComponent implements OnInit {
  showConsent = false;

  ngOnInit(): void {
    if (!localStorage.getItem('cookie_consent')) {
      this.showConsent = true;
    }
  }

  accept(): void {
    localStorage.setItem('cookie_consent', 'accepted');
    this.showConsent = false;
  }

  decline(): void {
    localStorage.setItem('cookie_consent', 'declined');
    this.showConsent = false;
  }
}
